/**
 * query parameters used for campaign attribution, based on the legacy plugin
 * @see https://www.npmjs.com/package/@amplitude/plugin-web-attribution-browser
 * @see https://github.com/amplitude/Amplitude-TypeScript/blob/a810cb15d56f058d5eea1e8c53da430c5113bb3d/packages/analytics-client-common/src/attribution/constants.ts#L5
 */
export const CAMPAIGN_PARAMS = [
  'utm_id',
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'dclid',
  'gbraid',
  'gclid',
  'fbclid',
  'ko_click_id',
  'li_fat_id',
  'msclkid',
  'rtd_cid',
  'ttclid',
  'twclid',
  'wbraid',
  'referrer',
  'referring_domain',
] as const;

export type CampaignParam = (typeof CAMPAIGN_PARAMS)[number];

export type CampaignParams = { [key in CampaignParam]?: string };
